import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree, } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../auth.service';
import { map, take, tap,} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaginasGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router){

}

canActivate(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

  // Entrada desde el panel de admin: URL con #t=<código> → dejar pasar aunque haya sesión
  const fragmento = new URLSearchParams(route.fragment || window.location.hash.replace(/^#/, ''));
  if (fragmento.get('t')) {
    return true;
  }

  return this.authService.status().pipe(
    take(1),
    map(user => user === null ? true : false),
    tap(sinSesion => {
      if (!sinSesion) {
        this.router.navigate(['/tabs/feed']);
      }
    })
  );
  }

}
  
